import { Link, Route, Routes } from 'react-router-dom'

import ErrorBoundary from './components/error-boundary'
import ImageViewer from './components/image-viewer'

import CreateListingForm from './forms/create-listing-form'
import CustomOwnershipForm from './forms/custom-ownership-form'
import EditListingForm from './forms/edit-listing-form'
import OrganisationForm from './forms/organisation-form'
import OwnershipForm from './forms/ownership-form'
import ProductForm from './forms/product-form'
import UserForm from './forms/user-form'

import AdminCommunityRequest from './admin/admin-community-request'
import AdminCommunityRequests from './admin/admin-community-requests'
import AdminOrganisations from './admin/admin-organisations'
import AdminOwnerships from './admin/admin-ownerships'
import AdminProducts from './admin/admin-products'
import AdminUsers from './admin/admin-users'
import AnalyticsDashboard from './admin/analytics-dashboard'
import AdminLayout from './admin/layout'
import Contact from './app/contact'
import Home from './app/home'
import AppLayout from './app/layout'
import OwnershipDetails from './app/ownership-details'
import Settings from './app/settings'
import Login from './auth/login'
import Logout from './auth/logout'
import Register from './auth/register'
import RequestReset from './auth/request-reset'
import ResetEmail from './auth/reset-email'
import ResetPassword from './auth/reset-password'

export default function App() {
    return (
        <ErrorBoundary componentName='App (top level catch)'>
            <Routes>
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
                <Route path='/logout' element={<Logout />} />
                <Route path='/request-reset' element={<RequestReset />} />
                <Route path='/passwordReset' element={<ResetPassword />} />
                <Route path='/email-reset' element={<ResetEmail />} />
                <Route path='/404' element={<NotFound />} />

                <Route path='/' element={<AppLayout />}>
                    <Route index element={<Home />} />
                    <Route path='/ownership/:id' element={<OwnershipDetails />} />
                    <Route path='/:id' element={<OwnershipDetails />} />
                    {/* <Route path='/organisation/:id' element={<JoinOrganisation />} />
                    <Route path='/join-organisation/:id' element={<JoinOrganisation />} /> */}
                    <Route path='/create-ownership/:id' element={<CustomOwnershipForm />} />
                    <Route path='/create-listing/:id' element={<CreateListingForm />} />
                    <Route path='/edit-listing/:id' element={<EditListingForm />} />
                    {/* <Route path='/marketplace' element={<Marketplace />} />
                    <Route path='/listing/:id' element={<ListingDetail />} /> */}
                    <Route path='/contact' element={<Contact />} />
                    <Route path='/settings' element={<Settings />} />
                    {/* <Route path='/request-community' element={<RequestCommunity />} />
                    <Route path='/communities' element={<Communities />} /> */}
                </Route>
                <Route path='/admin' element={<AdminLayout />}>
                    <Route index element={<AdminUsers />} />
                    <Route path='/admin/manage-user/:id' element={<UserForm />} />
                    <Route path='/admin/products' element={<AdminProducts />} />
                    <Route path='/admin/manage-product/:id' element={<ProductForm />} />
                    <Route path='/admin/ownerships' element={<AdminOwnerships />}></Route>
                    <Route path='/admin/manage-ownership/:id' element={<OwnershipForm />}></Route>
                    <Route path='/admin/organisations' element={<AdminOrganisations />}></Route>
                    <Route path='/admin/manage-organisation/:id' element={<OrganisationForm />}></Route>
                    <Route path='/admin/analytics' element={<AnalyticsDashboard />}></Route>
                    <Route path='/admin/org-requests' element={<AdminCommunityRequests />}></Route>
                    <Route path='/admin/org-request/:id' element={<AdminCommunityRequest />}></Route>
                </Route>
            </Routes>
        </ErrorBoundary>
    )
}

function NotFound() {
    return (
        <div className='flex flex-col justify-center items-center h-screen'>
            <ImageViewer width={128} height={128} />
            <h1 className='text-4xl font-bold'>404 - Page Not Found</h1>
            <p className='text-lg'>The page you are looking for does not exist.</p>
            <Link to='/' className='text-blue-500 hover:text-blue-700'>
                Go back to the home page
            </Link>
        </div>
    )
}
